module.exports = __webpack_public_path__ + "img/9788992055314.6f7c0ac6.jpg";